<p-select
  test-id="workflow-selection-type-or-search-for-approval-workflow"
  [(ngModel)]="value"
  [placeholder]="isLoading() ? 'Loading...' : 'Type or search for Approval Workflow'"
  [options]="workflowList()"
  [filter]="true"
  [disabled]="disabled || currentStatus() !== WORKFLOW_STATUS.DRAFT"
  [showClear]="true"
  fluid
  optionLabel="name"
  optionValue="id"
  filterBy="name" />
